import React from "react";
import { Chart } from "react-google-charts";

function PieChart({data}) {
    var options = {
          title: "Calculalations by user type",
          is3D: true,

        };
    
    return (
      <Chart
      chartType="PieChart"
      data={data}
      options={options}
      width={"100%"}
      height={"400px"}
    />
    );
  }
  function PieChartProduct({dataprod}) {
    var options = {
          title: 'Calculations per product type',
        };
    
    return (
      <Chart
      chartType="PieChart"
      data={dataprod}
      options={options}
      width={"100%"}
      height={"400px"}
    />
    );
  }
  
  function Linechart({data2}) {
    var options = {
        chart: {
          title: "Calculations Count Per Month",
          subtitle: "Last 12 Months Caclculation Chart",
        },
      };
  return (
    <Chart
      chartType="Line"
      width="100%"
      height="400px"
      data={data2}
      options={options}
    />
  );
}

function Barchart({data3}) {
    var options = {
        chart: {
          title: "Calculations per segment in %",
        },
      };
  return (
    <Chart
      chartType="Bar"
      width="80%"
      height="400px"
      data={data3}
      options={options}
    />
  );
}
function BarCountires({datacountries}) {
  var options = {
      chart: {
        title: "Calculations top 10 Countires",
      },
    };
return (
  <Chart
    chartType="Bar"
    width="70%"
    height="400px"
    data={datacountries}
    options={options}
  />
);
}




export {PieChart, PieChartProduct, Linechart, Barchart, BarCountires};